var map = {
	"./0.png": 162,
	"./1.png": 163,
	"./2.png": 164,
	"./3.png": 165,
	"./4.png": 166,
	"./5.png": 167,
	"./6.png": 168,
	"./7.png": 169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 161;